import React, { memo } from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

let BetterCareIcon = (props) => (
	<SvgIcon {...props} viewBox={"0 0 41 34"}>
		<title>Better Care</title>
		<path
			fill="#F2625A"
			d="M36.63 18.143l.908-.909a9.82 9.82 0 0 0 2.178-3.207c.516-1.217.789-2.538.789-3.927C40.505 4.527 35.978 0 30.37 0c-2.795 0-5.314 1.132-7.15 2.967l-.926.892L20.237 5.9l4.424 4.39 2.041-2.058.908-.875c.754-.738 1.715-1.149 2.76-1.149 1.235 0 2.332.583 3.053 1.491h0a3.74 3.74 0 0 1 .84 2.384c0 1.045-.394 2.006-1.131 2.743l-.926.926-2.023 2.041 4.406 4.391 2.041-2.041"
		/>
		<path
			fill="#00A1F2"
			d="M10.663 24.911l2.127 2.126 2.041-2.024 2.366-2.384-9.929-9.894-4.424 4.407 6.293 6.259"
		/>
		<path
			fill="#32CC86"
			d="M24.658 30.112l9.946-9.928-4.423-4.391-9.93 9.913-5.521-5.505-4.407 4.389 5.522 5.522-.018.017 4.424 4.166 4.426-4.183z"
		/>
		<path
			fill="#00A1F2"
			d="M5.901 20.184l4.424-4.391-2.932-2.95a3.88 3.88 0 0 1-1.115-3.309 3.88 3.88 0 0 1 3.207-3.258c1.269-.206 2.503.206 3.396 1.081l7.374 7.339 4.407-4.407-7.374-7.322C15.299.978 12.486-.171 9.417.035 4.546.36.533 3.996.054 8.832c-.326 3.189.857 6.345 2.915 8.402l2.932 2.95z"
		/>
	</SvgIcon>
);

BetterCareIcon = memo(BetterCareIcon);
BetterCareIcon.displayName = "BetterCareIcon";
BetterCareIcon.muiName = "BetterCareIcon";

export default BetterCareIcon;
